<div bsModal #loginModal="bs-modal" class="modal fade" [config]="{ keyboard: false, backdrop: 'static' }" tabindex="-1" role="dialog" aria-labelledby="loginModal" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">
            <form (ngSubmit)="login()" #loginForm="ngForm">
                <div class="modal-header">
                    <h4 class="modal-title" id="loginModal">Login</h4>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="form-group input-group has-feedback">
                                <label class="input-group-addon">User Name</label>
                                <input type="text" class="form-control" id="userName"
                                       required placeholder="User Name"
                                       [focus]="userNameFocus" tabindex="1"
                                       [ngClass]="{ 'has-error' : !modelUserNameControl.valid }"
                                       [(ngModel)]="userName" name="userName"
                                       #modelUserNameControl="ngModel" />
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <div class="form-group input-group has-feedback">
                                <label class="input-group-addon">Password</label>
                                <input type="password" class="form-control" id="password"
                                       required
                                       [focus]="passwordFocus" tabindex="2"
                                       [ngClass]="{ 'has-error' : !modelPasswordControl.valid }"
                                       [(ngModel)]="password" name="password"
                                       #modelPasswordControl="ngModel" />
                            </div>
                        </div>
                    </div>
                    <p>*Only Admin users can log into this site.</p>
                </div>
                <div class="modal-footer">
                    <button *ngIf="forgotPasswordVisible" type="button" class="btn btn-warning" (click)="forgotPassword()">Forgot Password</button>
                    <button type="submit" class="btn btn-primary" [disabled]="!loginForm.form.valid" [focus]="loginFocus" tabindex="3">Login</button>
                    <button type="button" class="btn btn-primary" (click)="cancelLogin()" tabindex="4">Cancel</button>
                </div>
            </form>
        </div>
    </div>
</div>



<div bsModal #forgotPasswordModal="bs-modal" class="modal fade" [config]="{ keyboard: false, backdrop: 'static' }" tabindex="-1" role="dialog" aria-labelledby="forgotModal" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">
            <form (ngSubmit)="submitAnswer()" #forgotForm="ngForm">
                <div class="modal-header">
                    <h4 class="modal-title" id="forgotModal">Login &bull; Forgot Password</h4>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="input-group">
                                <label class="input-group-addon">User Name</label>
                                <input type="text" class="form-control" [(ngModel)]="userName" name="userName" disabled />
                            </div>
                        </div>
                    </div>
                    <hr />
                    <div class="row">
                        <div class="col-md-12">
                            <div class="input-group">
                                <label class="input-group-addon">Security Question</label>
                                <input disabled class="form-control" [(ngModel)]="securityQuestion" name="securityQuestion">
                                <input type="hidden" [(ngModel)]="securityQuestionId" name="securityQuestionId" />
                            </div>
                        </div>
                    </div>
                    <br />
                    <div class="row">
                        <div class="col-md-12">
                            <div class="form-group input-group has-feedback">
                                <label class="input-group-addon">Answer</label>
                                <input #modelAnswerControl="ngModel" type="text" class="form-control" [focus]="answerFocus" [(ngModel)]="answer" required name="answer" [ngClass]="{ 'has-error' : !modelAnswerControl.valid }" />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-warning" (click)="goBack()">Go Back</button>
                    <button type="submit" class="btn btn-primary" [disabled]="!forgotForm.form.valid">Submit Answer</button>
                </div>
            </form>
        </div>
    </div>
</div>